import {ChangeDetectionStrategy, Component, Inject, Input, OnInit} from '@angular/core';
import {ServiceType} from "../../../../deliveries/types/service.type";

require('./task-relation-card.scss');
@Component({
  standalone: false,
  selector: 'app-task-relation-card',
  templateUrl: './task-relation-card.html',
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class TaskRelationCardComponent implements OnInit {

  @Input() relation: any;

  public serviceTypes: typeof ServiceType = ServiceType;
  public isDisplayExternal: boolean;

  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.isDisplayExternal = this.splitService.getSiteExternalIdConfig();
  }
}
